import { Box } from "@mui/system"
import CircularIndeterminate from "components/blocks/progressBar/progressBar"
import ButtonMedium1 from "components/elements/ButtonMedium1"
import ContentNormal from "components/elements/ContentNormal"
import Headline2 from "components/elements/Headline2"
import SectionWrapper from "components/layouts/SectionWrapper"
import { useContext, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import NoMatch from "components/elements/NoMatch";
import { callAPI } from "utils/API"
import { AppContext } from "contexts/AppContext"
import { setupUserData } from "utils/setup"
import { setupBasketData } from 'utils/setup';

export const OrderConfirmation = () => {
    const navigate = useNavigate()
    const { ConfirmationID } = useParams()
    const contextState = useContext(AppContext)
    const { brandData, setBasket, userData } = contextState
    const [confirmation, setConfirmation] = useState(null)
    const [isLoading, setIsLoading] = useState(true)

    const fetchConfirmation = async () => {
        const confirmation = await callAPI(`/confirmation/${ConfirmationID}`, 'GET')
        if(confirmation?.ConfirmationID){
            setConfirmation(confirmation)
        }
        setIsLoading(false)
    }

    const clearBasket = async () => {
        await callAPI(`/basket`, 'DELETE')
        await setupBasketData({ userData, setBasket });
    }

    useEffect(() => {
        fetchConfirmation()
        clearBasket()

        // Fetch user data to ensure that the wallet points are updated after returning from the payment provider
        setupUserData(contextState, () => {})
    }, [])

    if(isLoading){
        return <CircularIndeterminate size={100} style={{alignSelf: 'center', marginTop: 10}}/>
    }

    if(!isLoading && !confirmation){
        return <NoMatch />
    }

    return (
        <SectionWrapper sx={{minHeight: '60vh'}}>
            <Box sx={{paddingTop: 14}} display={'flex'} flexDirection={'column'} gap={4}>
                <Box display={'flex'} gap={4}>
                    <Headline2
                        translationKey="_BASKET_CAPTION_ORDER_CONFIRMATION"
                        fallbackText="Ordrebekræftelse"
                    />
                    <Headline2>#{confirmation.ConfirmationID}</Headline2>
                </Box>
                <Box display={'flex'} flexDirection={'column'} gap={4}>
                    <Box display={'flex'} flexDirection={'column'} gap={2}>
                        <ContentNormal
                            translationKey="_BASKET_ORDER_CONFIRMATION_MESSAGE_LINE_1_"
                            fallbackText="Tak for din ordre. Lagervarer afsendes indenfor 3-4 hverdage.
                            Du modtager en SMS og/eller email, når din ordre sendes fra
                            lageret."
                        />
                        {!brandData.isPublicClub && 
                            <ContentNormal
                                translationKey="_BASKET_ORDER_CONFIRMATION_MESSAGE_LINE_2_"
                                fallbackText="Du kan følge din ordrestatus under din profil."
                            />
                        }
                    </Box>
                    {!brandData.isPublicClub && (
                        <Box>
                            <ButtonMedium1
                                showIcon={false}
                                translationKey="_GO_TO_PROFILE_BUTTON_TEXT_"
                                fallbackText={"Gå til din profil"}
                                onClick={() => navigate("/profile/orders")}
                            />
                        </Box>
                    )}
                </Box>
            </Box>
        </SectionWrapper>
    )
}

